import { DialogContent, DialogTitle } from "@mui/material"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { CreateSkillMapFormBody } from "./create-skill-map-form-body"

export function CreateSkillMapDialog({ regimeId }) {
    return (
        <DataInputDialog
            initialValue={{
                name: "",
                description: "",
                startingPoint: "defaults",
                sourceSkillMapId: null,
                regimeId: regimeId || null,
            }}
            okCaption="Create"
            okDisabled={isInvalid}
        >
            <DialogTitle sx={{ pb: 3 }}>Create Skill Map</DialogTitle>
            <DialogContent sx={{ pb: 0.5 }}>
                <CreateSkillMapFormBody />
            </DialogContent>
        </DataInputDialog>
    )
}

function isInvalid(v) {
    if (!v?.name?.trim()) return true
    if (v?.startingPoint === "existing" && !v?.sourceSkillMapId) return true
    return false
}
